import uuid from "uuid/v1";
import {
  createAppliedPriceTriggerPart,
  createItemAppliedPriceTriggerPart,
} from "../helpers/priceTriggerHelpers";
import store from "../../store/index";
import { priceTriggerType } from "../constants/priceTriggerEnums";
import { AppConfig } from "../../../AppConfig";
import { getServerTime } from "../helpers/datetimeHelper";
import { source } from "../../constants/strings";

function CreatOrderItemObj(item, priceTriggers, appliedCoupon, orderNo) {
  var productTotalTax = 0;
  var productTotalPrice = 0;
  var productTax = computeTax({
      price: item.price,
      taxRate: item.tax,
  });
  productTotalTax += productTax;
  productTotalPrice += item.price;
  let orderitem = {
    CreatedOn: getServerTime().toUTCString(),
    AppliedCoupon: appliedCoupon,
    DisplayingOrder: orderNo,
    FinalTotalExcludingTax: 0,
    FinalTotalTax: 0,
    ModifyingExcludingTax: 0,
    ModifyingTax: 0,
    Name: item.name,
    Note: item.itemNote,
    OrderExtras: [],
    Product_ID: item.id,
    Quantity: item.quantity,
    Timestamps: [],
    UDID: uuid(),
    UsingTaxRate: item.tax,
    BaseUnitPrice: item.price,
    uniqueId: item.uniqueId,
    CategoryId: item.categoryId,
    CategoryName: item.categoryName,
  };

  if (item.modifiers) {
    for (var [index, md] of item.modifiers.entries()) {
      var mdQuantity = md.quantity;
      var mdTaxRate = md.TaxRate ? md.TaxRate : item.tax;
      var mdTax = computeTax({
        price: md.Price * mdQuantity,
        taxRate: mdTaxRate,
      });
      var mdPriceExcludingTax = md.Price * mdQuantity - mdTax;
      var extra = {
        DisplayingOrder: index + 1,
        Extra_ID: md.ID,
        FinalPriceExcludingTax: fix2digit(mdPriceExcludingTax),
        FinalTax: mdTax,
        Name: md.Name,
        Quantity: mdQuantity,
        UDID: uuid(),
        UsingUnitPrice: md.Price,
      };
      if (md.selectedSubmodifiers) {
        extra.ChildrenOrderExtras = [];
        for (var [subindex, sub] of md.selectedSubmodifiers.entries()) {
          var subQuantity = sub.quantity;
          var subTaxRate = sub.TaxRate ? sub.TaxRate : item.tax;
          var subTax = computeTax({
            price: sub.Price * subQuantity,
            taxRate: subTaxRate,
          });
          var subPriceExcludingTax = sub.Price * subQuantity - subTax;
          var subextra = {
            DisplayingOrder: subindex + 1,
            Extra_ID: sub.ID,
            FinalPriceExcludingTax: fix2digit(subPriceExcludingTax),
            FinalTax: subTax,
            Name: sub.Name,
            Quantity: subQuantity,
            UDID: uuid(),
            UsingUnitPrice: sub.Price,
          };
          extra.ChildrenOrderExtras.push(subextra);
          productTotalTax += subTax;
          productTotalPrice += subPriceExcludingTax + subTax;
        }
      }
      orderitem.OrderExtras.push(extra);
      productTotalTax += mdTax;
      productTotalPrice += mdPriceExcludingTax + mdTax;
    }
  }
  productTotalTax = productTotalTax * item.quantity;
  orderitem["UsingUnitPrice"] = fix2digit(productTotalPrice);
  productTotalPrice = productTotalPrice * item.quantity;
  orderitem["FinalTotalTax"] = fix2digit(productTotalTax);
  orderitem["FinalTotalExcludingTax"] = fix2digit(
    productTotalPrice - productTotalTax
  );
  orderitem.AppliedPriceTriggerRecords = createItemAppliedPriceTriggerPart(
    orderitem,
    priceTriggers
  );
  return orderitem;
}

function createOrderItem(item, priceTriggers, appliedCoupon, orderNo) {
  var orderitem = CreatOrderItemObj(
    item,
    priceTriggers,
    appliedCoupon,
    orderNo
  );
  return orderitem;
}
export function getAppliedCoupon(item, appliedCouponList) {
  if (!appliedCouponList) {
    return null;
  }
  var AppliedCoupon = null;
  appliedCouponList.forEach((applied) => {
    var items = applied.appliedItems.map((a) => {
      return a.item.id;
    });
    var id = items.indexOf(item.id);
    if (id != -1) {
      AppliedCoupon = {
        CouponCode: applied.coupon.CouponCode,
        Name: applied.coupon.Name,
        Amount: applied.appliedItems[id].discount,
      };
    }
  });
  return AppliedCoupon;
}
export function CreateOrderObject(
  cartItems,
  deliveryFee,
  priceItem,
  user,
  resturant,
  card,
  guid,
  orderInfo,
  guestUserId,
  priceTriggers,
  appliedCouponList,
  guestCount
) {
  let orderItems = [];
  let totalTax = fix2digit(priceItem.totalTax);
  const tip = priceItem.TipAmount;
  let totalAmount = fix2digit(priceItem.totalPrice - tip);

  let SubtotalTax = 0;
  let SubtotalExcludingTax = 0;
  // let freightTax = fix2digit(
  //   computeTax({
  //     price: deliveryFee,
  //     taxRate: 0.1,
  //   })
  // );
  let freightTax = 0;
  let freightExcludingTax = deliveryFee - freightTax;
  for (var i = 0; i < cartItems.length; i++) {
    var item = cartItems[i];
    var orderitem = createOrderItem(
      item,
      priceTriggers,
      getAppliedCoupon(item, appliedCouponList),
      orderItems.length + 1
    );

    orderItems.push(orderitem);
    SubtotalTax += orderitem.FinalTotalTax;
    SubtotalExcludingTax += orderitem.FinalTotalExcludingTax;

    var result = store.getters.getPriceTriggerOutcomes.find((oc) => {
      return (
        oc.order == item.uniqueId &&
        oc.type == priceTriggerType.rollIntoMealPriceTriggers &&
        Array.isArray(oc.selectedRollIntos) &&
        oc.selectedRollIntos.some((x) => x && x.isConfirmed)
      );
    });

    if (
      result &&
      result.selectedRollIntos &&
      result.selectedRollIntos.length > 0
    ) {
      for (let j = 0; j < result.selectedRollIntos.length; j++) {
        const { ProductID } = result.rollIntoProduct;
        const productList = store.getters.getAllStoreMenus.map((menu) => {
          return menu.Products;
        });
        const product = Object.assign({}, ...productList)[ProductID];
        const ct = [].concat.apply(
          [],
          store.getters.getAllStoreMenus.map((menu) => {
            return menu.Categories;
          })
        );
        const categories = ct
          .filter((cat) => cat && cat.SubMenuItems)
          .map((cat) => {
            return cat.SubMenuItems.map((item) => {
              return {
                ...item,
                parentCategory: {
                  ID: cat.ID,
                  Name: cat.Name,
                },
              };
            });
          });
        const category = [].concat(...categories).find((item) => {
          return item.ProductID == ProductID;
        }) || {
          Name: product.Name,
          parentCategory: {
            ID: null,
            Name: null,
          },
        };
        const fullProduct = {
          id: ProductID,
          uniqueId: uuid(),
          itemNote: "",
          code: product.ProductCode,
          name: category.Name,
          description: product.ShortDescription,
          photoUrl: product.PhotoUrl,
          tax: product.TaxRate,
          RewardPoint: product.RewardPoint,
          price: result.FixedPriceValue,
          categoryId: category.parentCategory.ID,
          categoryName: category.parentCategory.Name,
          quantity: 1,
          PreparationTime: product.PreparationTime,
          ProductCategoryIDs: product.ProductCategoryIDs,
          ProductTagIDs: product.ProductTagIDs,
          modifiers: result.selectedRollIntos[j].selectedModifiers,
        };

        const newOrderItem = createOrderItem(
          fullProduct,
          priceTriggers,
          getAppliedCoupon(fullProduct, appliedCouponList),
          orderItems.length + 1
        );
        orderItems.push(newOrderItem);
        SubtotalTax += newOrderItem.FinalTotalTax;
        SubtotalExcludingTax += newOrderItem.FinalTotalExcludingTax;
      }
    }
  }

  if (priceItem.freeOrderItems) {
    for (i = 0; i < priceItem.freeOrderItems.length; i++) {
      item = priceItem.freeOrderItems[i];
      orderitem = createOrderItem(
        item,
        priceTriggers,
        getAppliedCoupon(item, appliedCouponList) + cartItems.length + i + 1
      );
      orderItems.push(orderitem);
    }
  }

  let model = {
    BankCardSurcharge: priceItem.bankCardSurcharge,
    CallbackUrlOnOrderAcceptance: "",
    ContactCustomer_Contact_Number: user.Phone,
    ContactCustomer_DisplayName: user.DisplayName,
    ContactCustomer_FirstName: user.FirstName,
    ContactCustomer_LastName: user.LastName,
    ContactCustomer_Email_Address: user.Email,
    CreatedOn: getServerTime().toUTCString(),
    CustomerMemberCode: user.CustomerMemberCode,
    DiscountExcludingTax: priceItem.discountExcludingTax,
    DiscountTax: priceItem.discountTax,
    FreightExcludingTax: freightExcludingTax,
    FreightTax: freightTax,
    GuestUserIdentifier: user.IsGuest ? guestUserId : "",
    InvoiceNumber: "",
    OrderNote: orderInfo.notes,
    DeliveryNote: orderInfo.DeliveryInstructions,
    OrderNumber: null,
    OnlineOrderStatus: 1,
    OnlineOrderStatusDescription: "",
    OnlineOrderUserIdentifier: user.IsGuest ? "" : user.ID,
    OrderItems: orderItems,
    DeliveryAddress: orderInfo.DeliveryAddress,
    OrderDeliveryTime: orderInfo.OrderDeliveryTime,
    OrderType: orderInfo.orderType,
    SubsidyOnThirdPartyDeliveryFee: orderInfo.subsidyFee,
    PaymentTransactions: [
      {
        Amount: totalAmount,
        PaymentMethodType: 0,
      },
    ],
    SurchargeTransactions: priceItem.surchargeTransactions,
    PaymentReferences: null,
    POSSurchargeExcludingTax:
      priceItem.pOSSurchargeExcludingTax - priceItem.pOSSurchargeTax,
    POSSurchargeTax: priceItem.pOSSurchargeTax,
    PaymentCardIdentifier: card ? (card.isToken ? card.token : "") : "",
    ScheduledTime:
      orderInfo.orderType === 2
        ? getServerTime().toUTCString()
        : orderInfo.scheduledTime,
    StoreID: resturant.ID,
    StoreName: resturant.Name,
    SubtotalExcludingTax: fix2digit(SubtotalExcludingTax),
    SubtotalTax: fix2digit(SubtotalTax),
    Source: source,
    SourceReference_ID: "",
    Timestamps: [],
    timeslotRangeEnd: orderInfo.timeslotRangeEnd,
    TotalExcludingTax: fix2digit(totalAmount - totalTax),
    TotalTax: totalTax,
    TipAmount: tip,
    UDID: guid,
    AgreeToReceivePromotionalOffers: user.JoinOurMail,
    AppliedPriceTriggerRecords: createAppliedPriceTriggerPart(
      orderItems,
      priceTriggers
    ),
  };

  if (tip) {
    model.PaymentTransactions[0].IntegratedTips = tip;
    model.PaymentTransactions[0].UDID = uuid();
    const tipModel = {
      Amount: tip,
      PaymentMethodType: 99,
      TipsPaymentReference: model.PaymentTransactions[0].UDID,
      Type: 23,
      UDID: uuid()
    };
    model.PaymentTransactions.push(tipModel);
  }

  if (orderInfo.orderType === 8 || orderInfo.orderType === 2) {
    model.GuestCount = guestCount ? guestCount : 0;
  }

  return model;
}

export function CreateGiftOrderObject(
  cartState,
  surchargeItem,
  user,
  resturant,
  card,
  guid,
  orderInfo,
  appliedCouponList
) {
  let orderItems = [];
  let totalTax = 0;
  let deliveryFee = cartState.isDelivery ? cartState.deliveryFee : 0;
  let freightTax = 0;
  let freightExcludingTax = deliveryFee - freightTax;
  for (var i = 0; i < cartState.cartItems.length; i++) {
    var item = cartState.cartItems[i];
    var itemTaxAmount = 0;
    var itemPriceWithoutTax = item.price - itemTaxAmount;
    totalTax += itemTaxAmount * item.quantity;
    var orderitem = {
      CreatedOn: getServerTime().toUTCString(),
      AppliedCoupon: getAppliedCoupon(item, appliedCouponList),
      DisplayingOrder: i + 1,
      FinalTotalExcludingTax: 0,
      FinalTotalTax: 0,
      ModifyingExcludingTax: 0,
      ModifyingTax: 0,
      Name: item.name,
      OrderExtras: [],
      Product_ID: item.id,
      Quantity: item.quantity,
      Timestamps: [],
      UDID: uuid(),
      UsingTaxRate: item.tax,
      UsingUnitPrice: item.price,
      AdditionalDataType: "GiftCardDetailType",
      AdditionalData: {
        FromName: item.message.From || user.FirstName + " " + user.LastName,
        ToName: item.message.To,
        ToEmail: item.message.Email,
        Message: item.message.Message,
      },
    };
    orderitem["FinalTotalTax"] = itemTaxAmount * item.quantity;
    orderitem["FinalTotalExcludingTax"] = itemPriceWithoutTax * item.quantity;
    orderItems.push(orderitem);
  }
  let totalAmount = surchargeItem.totalPrice;
  var SubTotalAmount = surchargeItem.subTotalPrice;
  //delivery price and tax
  totalAmount += deliveryFee;
  totalTax += freightTax;
  let model = {
    BankCardSurcharge: surchargeItem.bankCardSurcharge,
    CallbackUrlOnOrderAcceptance: "",
    ContactCustomer_Contact_Number: user.Phone,
    ContactCustomer_DisplayName: user.DisplayName,
    ContactCustomer_Email_Address: user.Email,
    CreatedOn: getServerTime().toUTCString(),
    CustomerMemberCode: user.CustomerMemberCode,
    DiscountExcludingTax: surchargeItem.DiscountExcludingTax,
    DiscountTax: 0,
    FreightExcludingTax: freightExcludingTax,
    FreightTax: freightTax,
    GuestUserIdentifier: user.IsGuest ? uuid() : "",
    InvoiceNumber: "",
    OrderNumber: null,
    IsLiability: true,
    OnlineOrderStatus: 1,
    OnlineOrderStatusDescription: "",
    OnlineOrderUserIdentifier: user.IsGuest ? "" : user.ID,
    OrderItems: orderItems,
    DeliveryAddress: orderInfo.DeliveryAddress,
    OrderType: orderInfo.orderType,
    PaymentTransactions: [
      {
        Amount: totalAmount,
        PaymentMethodType: 0,
      },
    ],
    PaymentReferences: null,
    SurchargeTransactions: surchargeItem.surchargeTransactions,
    POSSurchargeExcludingTax:
      surchargeItem.pOSSurchargeExcludingTax - surchargeItem.pOSSurchargeTax,
    POSSurchargeTax: surchargeItem.pOSSurchargeTax,
    PaymentCardIdentifier: card ? (card.isToken ? card.token : "") : "",
    ScheduledTime:
      orderInfo.orderType === 2
        ? getServerTime().toUTCString()
        : orderInfo.scheduledTime,
    StoreID: resturant.ID,
    StoreName: resturant.Name,
    SubtotalExcludingTax: fix2digit(SubTotalAmount - totalTax),
    SubtotalTax: totalTax,
    Source: source,
    SourceReference_ID: "",
    Timestamps: [],
    timeslotRangeEnd: orderInfo.timeslotRangeEnd,
    TotalExcludingTax: totalAmount - totalTax,
    TotalTax: totalTax,
    UDID: guid,
  };
  return model;
}
export function fix2digit(value) {
  return Number(parseFloat(value).toFixed(2));
}

export function computeTax(item) {
  return item.price - (item.price * 100) / (item.taxRate * 100 + 100);
}
export function DiscountTax(totalTax, cartValue, discount) {
  var shopTaxRate = totalTax / cartValue; //tax rate is not always 10% so we use this to caluclate total tax percentage for the cart
  var discountValueTax =
    shopTaxRate * (discount > cartValue ? cartValue : discount);
  return fix2digit(discountValueTax);
}
export function positive(val) {
  return val < 0 || !val ? 0 : val;
}
export function TotalTaxExcludingDicountTax(cartItems) {
  let totalTax = 0;
  for (let i = 0; i < cartItems.length; i++) {
    const item = cartItems[i];
    if (!item.modifiers) {
      item.modifiers = [];
    }
    const itemTaxAmount = computeTax({
        price: item.price,
        taxRate: item.tax,
    });
    totalTax += itemTaxAmount * item.quantity;

    for (let j = 0; j < item.modifiers.length; j++) {
      const md = item.modifiers[j];
      const quantity = item.modifiers[j].quantity;
      const mdTaxRate = md.TaxRate ? md.TaxRate : item.tax;
      const mdTax = computeTax({
          price: md.Price,
          taxRate: mdTaxRate,
      });
      totalTax += mdTax * quantity * item.quantity;
    }
  }
  return fix2digit(totalTax);
}
export function TotalTax(cartItems, cartValue, discount, surchargeHolidayTax) {
  let totalTax = TotalTaxExcludingDicountTax(cartItems);
  totalTax -= DiscountTax(totalTax, cartValue, discount);
  totalTax += surchargeHolidayTax ? surchargeHolidayTax : 0;
  return fix2digit(totalTax);
}
export function isProduction() {
  return AppConfig.abacusCoreApiBaseUrl.includes("live");
}
